import { ChallengesPage as ChallengesPageComponent } from "../features/challenges";

export function ChallengesPage() {
  return <ChallengesPageComponent />;
}
